import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Grid, Menu } from 'semantic-ui-react';
import { compose } from 'recompose';

import CampaignDashboardHeader from '../../components/campaign-dashboard-header';
import AddAssetForm from '../../components/add-asset-form';
import AddInfluencerModal from '../../components/add-influencer-modal';

import hasRESTClient from '../../hocs/has-rest-client';
import hasJSONAPIClient from '../../hocs/has-jsonapi-client';

import { getTrackedAssetAnalytics } from '../../utils/tracked-assets-analytics-service';
const ASSETS_PER_PAGE = 200;

const DashboardMenu = ({ menuOptions, clickHandler }) => (
  <Menu fluid vertical>
    {
      _.map(menuOptions, option => (
        <Menu.Item
          key={option.name}
          active={option.active}
          name={option.name}
          className="dyzio-tab"
          icon={option.icon}
          onClick={clickHandler}
        />
      ))
    }
  </Menu>
);

class CampaignDashboardV2 extends Component {

  static contextTypes = {
    router: PropTypes.object,
  };

  constructor(props) {
    super(props);
    this.state = {
      campaign: null,
      overview: null,
      trackedAssets: [],
      tableViewTrackedAssets: [],
      assetModalOpen: false,
      influencerModalOpen: false,
      sortBy: 'createdBy',
      isAddingNewCard: false,
      isLoadingTrackedAssets: true,
      hasLoadedTrackedAssets: false,
      hasFailedToLoadTrackedAssets: false,
    };
  }

  componentDidMount() {
    this.fetchCampaign();
  }

  fetchCampaign = () => {
    const { restClient, params } = this.props;
    restClient.get(`/campaigns/${params.id}`)
    .then(response => {
      const { data: { data: { attributes } } } = response;
      this.setState({
        campaign: attributes,
      });
    }).catch(() => {
      this.setState({
        isAddingNewCard: false,
      });
    });
  }

  onAssetsSortByChanged = (event, data, shouldReloadAssetsData) => {
    const { value } = data;
    this.setState({
      sortBy: value,
    }, () => this.fetchTrackedAssets(shouldReloadAssetsData));
  }

  fetchTrackedAssets = shouldReloadAssetsData => {
    const { routeParams: { id }, restClient } = this.props;
    const { sortBy } = this.state;
    restClient.get(`trackedAssets?filter[campaign]=${id}&sort=${sortBy}&page[limit]=${ASSETS_PER_PAGE}`).then(response => {
      const { data: { data } } = response;
      this.setState({
        trackedAssets: data,
        isLoadingTrackedAssets: false,
        hasLoadedTrackedAssets: true,
        hasFailedToLoadTrackedAssets: false,
        isAddingNewCard: false,
      }, () => {
        if (shouldReloadAssetsData) {
          const tableViewDataRequest = _.map(data, 'attributes');
          getTrackedAssetAnalytics(tableViewDataRequest).then(rsp => {
            const tableViewTrackedAssets = _.map(rsp, 'response.data');
            this.setState({
              tableViewTrackedAssets,
            });
          });
        }
      });
    }).catch(() => {
      this.setState({
        hasFailedToLoadTrackedAssets: true,
        isLoadingTrackedAssets: false,
        hasLoadedTrackedAssets: false,
        isAddingNewCard: false,
      });
    });
  }

  toggleAddAssetModalState = () => {
    const { assetModalOpen } = this.state;
    this.setState({
      assetModalOpen: !assetModalOpen,
    });
  }

  handleMenuItemClick = (event, data) => {
    const { name } = data;
    const { params } = this.props;
    this.context.router.push(`/campaign/v2/${params.id}/${name}`);
  }

  isActiveRoute = name => {
    const { routes } = this.props;
    const active = _.last(routes);
    return active && active.path === name;
  }

  toggleAddInfluencerModalState = () => {
    const { influencerModalOpen } = this.state;
    this.setState({
      influencerModalOpen: !influencerModalOpen,
    });
  }

  render() {
    const { children } = this.props;

    const {
      campaign,
      influencerModalOpen,
      assetModalOpen,
    } = this.state;

    const props = _.assign({
      fetchCampaign: this.fetchCampaign,
      toggleAddAssetModalState: this.toggleAddAssetModalState,
      onAssetsSortByChanged: this.onAssetsSortByChanged,
    }, this.props);

    const menuOptions = [
      { name: 'assets', icon: 'clone outline', active: this.isActiveRoute('assets') },
      { name: 'overview', icon: 'eye', active: this.isActiveRoute('overview') },
      { name: 'influencers', icon: 'users', active: this.isActiveRoute('influencers') },
      { name: 'report', icon: 'bar graph', active: this.isActiveRoute('report') },
      { name: 'team', icon: 'add user', active: this.isActiveRoute('team') },
      { name: 'settings', icon: 'settings', active: this.isActiveRoute('settings') },
    ];

    const menuPaddingStyle = { padding: '15px 0px' };

    return (
      <div>
        { campaign &&
          <div className="page">
            <CampaignDashboardHeader
              name={campaign.name || 'Something went wrong'}
              addAssetActionHandler={this.toggleAddAssetModalState}
              addInfluencerActionHandler={this.toggleAddInfluencerModalState}
            />
            <div className="page-content">
              <Grid>
                <Grid.Column width={2} style={menuPaddingStyle}>
                  <DashboardMenu menuOptions={menuOptions} clickHandler={this.handleMenuItemClick} />
                </Grid.Column>
                <Grid.Column stretched width={14}>
                  { children && React.cloneElement(children, this.state, props) }
                </Grid.Column>
              </Grid>
            </div>
          </div>
        }
        {
          assetModalOpen &&
          <AddAssetForm
            platform="external"
            popupToggleHandler={this.toggleAddAssetModalState}
            addAssetHandler={this.addAssetHandler}
          />
        }
        {
          influencerModalOpen &&
          <AddInfluencerModal
            toggleHandler={this.toggleAddInfluencerModalState}
          />
        }
      </div>
    );
  }
}

CampaignDashboardV2.propTypes = {
  restClient: PropTypes.func.isRequired,
  jsonAPIClient: PropTypes.object.isRequired,
  params: PropTypes.object.isRequired,
  children: PropTypes.object.isRequired,
};

export default compose(
  hasRESTClient,
  hasJSONAPIClient,
)(CampaignDashboardV2);



/** WEBPACK FOOTER **
 ** ./src/containers/campaign-dashboard-v2/index.js
 **/